// export function transformCatalogAPI(data) {
//     const catalog = {};
//     data.forEach(mod => {
//         catalog[mod.privilegeName] = {
//             id: mod.adminPrivilegeId,
//             sub: mod.subTypes.map(s => s.subTypePrivilegeName)
//         };
//     });
//     return catalog;
// }

export function transformCatalogAPI(data) {
    const catalog = {};

    data.forEach(mod => {
        const idMap = {}; // ✅ map each subType name → its ID

        mod.subTypes.forEach(s => {
            idMap[s.subTypePrivilegeName] = s.adminPrivilegeSubTypeId;
        });

        catalog[mod.privilegeName] = {
            id: mod.adminPrivilegeId,
            sub: mod.subTypes.map(s => s.subTypePrivilegeName),
            idMap
        };
    });

    return catalog;
}